import { AUTH_MODE, type AuthConfig } from '@neotech-solutions-org/neofusion-fe-shared';
import { MARKETPLACE_AUTH_MODEL, MarketplaceAuthModel } from '../types/enums';
import { getKeycloakUrl, getKeycloakClientId } from '../utils/urlUtils';
import { runtimeEnv } from '../config/runtimeEnv';

const getKeycloakConfig = () => {
  const url = getKeycloakUrl();

  return {
    url: url.endsWith('/') ? url : `${url}/`,
    clientId: getKeycloakClientId(),
    realm: runtimeEnv.keycloakRealm ?? '',
    boRealm: runtimeEnv.keycloakBoRealm ?? '',
  };
};

export const getAuthConfig = (
  registrationModel: MarketplaceAuthModel = MARKETPLACE_AUTH_MODEL.AGENT_SYSTEM
): AuthConfig => {
  const keycloak = getKeycloakConfig();

  switch (registrationModel) {
    case MARKETPLACE_AUTH_MODEL.USER_REGISTRATION:
      return {
        mode: AUTH_MODE.CREDENTIALS,
        keycloak,
      };
    case MARKETPLACE_AUTH_MODEL.HYBRID:
      return {
        mode: AUTH_MODE.HYBRID,
        keycloak,
      };
    case MARKETPLACE_AUTH_MODEL.AGENT_SYSTEM:
    default:
      return {
        mode: AUTH_MODE.KEYCLOAK,
        keycloak,
        initOptions: {
          onLoad: 'login-required',
        },
      };
  }
};
